import RowItemReception from './RowItemReception.jsx';
export {
    RowItemReception
};



// WEBPACK FOOTER //
// ./src/components/modules/reception/datatable/list/index.js